import React, {useEffect, useState} from 'react';
import './index.style.less';
import {Grid} from 'antd';
import {isEmpty} from '../../../../utility/GlobalHelper';
import PropTypes from 'prop-types';
import {
  IoIosArrowDropleftCircle,
  IoIosArrowDroprightCircle,
} from 'react-icons/io';

const {useBreakpoint} = Grid;

const AppSidebarToggler = ({isCollapsed, onToggleSidebar}) => {
  const [isShow, setIsShow] = useState(true);
  const width = useBreakpoint();

  useEffect(() => {
    if (!isEmpty(width)) {
      if (width.xl) {
        setIsShow(true);
      } else {
        setIsShow(false);
      }
    }
  }, [width]);

  const icon = isCollapsed ? (
    <IoIosArrowDroprightCircle />
  ) : (
    <IoIosArrowDropleftCircle />
  );

  return (
    <>
      {isShow ? (
        <button className={'app-sidebar__toggler'} onClick={onToggleSidebar}>
          {icon}
        </button>
      ) : (
        <></>
      )}
    </>
  );
};

export default AppSidebarToggler;

AppSidebarToggler.propTypes = {
  onToggleSidebar: PropTypes.func,
  isCollapsed: PropTypes.bool,
};
